import apiRequest from 'helpers/apiRequest';

export const getPharmacyStatus = async () => {
  try {
    const response = await apiRequest({
      method: 'GET',
      url: `pharmacy/status`,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const enablePharmacy = async (data: any) => {
  try {
    const response = await apiRequest({
      method: 'POST',
      url: `pharmacy/enable`,
      payload: data,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
